import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";
import { tap, timeout } from 'rxjs/operators';
import { LabMDM } from '../masterdata/models/lab';
import { BBResponseContainer } from '../common-services/response-container';

//Service used for crud opertaions on the master data
@Injectable()
export class MdmProcessStepService {

    readonly MACHINETYPEMDMSERVICE = 'admin/mdm/machinetype';
    readonly PRINTERMDMSERVICE = 'admin/mdm/printer';
    readonly TEMPLATEMDMSERVICE = 'admin/mdm/print/template';

    constructor(private http: HttpClient) {
    }

    //Gets a list of machinetypes for selected Lab
    getMachineTypesByLab(lab:LabMDM, active: boolean): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.MACHINETYPEMDMSERVICE;
        let requestParam = new HttpParams().set('labId', lab._id).set('active', active.toString());
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

     //Gets a list of printers for Selected Lab
    getPrintersByLab(lab:LabMDM, active: boolean): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.PRINTERMDMSERVICE;
        let requestParam = new HttpParams().set('labId', lab._id).set('active', active.toString());
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Get all the templates for selected Lab
    getTemplatesByLab(lab:LabMDM, active: boolean): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.TEMPLATEMDMSERVICE;
        let requestParam = new HttpParams().set('labId', lab._id).set('active', active.toString());
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }
}